import { create } from "zustand";
import axios from "../lib/axios.js";
import { useCartStore } from "./useCartStores";

const normalizeOrders = (payload) => {
  const orders = payload?.orders ?? payload;
  return Array.isArray(orders) ? orders : [];
};

export const useOrderStore = create((set, get) => ({
  orders: [],
  loading: false,
  error: null,

  setOrders: (orders) => {
    set({ orders: normalizeOrders(orders) });
  },

  getOrders: async () => {
    set({ loading: true, error: null });

    try {
      const response = await axios.get("/orders");
      const orders = normalizeOrders(response.data);
      set({ orders, loading: false });
      return orders;
    } catch (error) {
      const message =
        error.response?.data?.message ||
        "Unable to load your orders";

      set({ orders: [], loading: false, error: message });
      throw error;
    }
  },

  getOrderById: async (orderId) => {
    try {
      const response = await axios.get(`/orders/${orderId}`);
      return response.data;
    } catch (error) {
      console.error(
        "Failed to fetch order:",
        error.response?.data || error.message
      );
      return null;
    }
  },

  createOrder: async (
    products,
    shippingAddress,
    totalPrice,
    reference,
    measurement,
    name,
    email,
    telephone,
    orderDate,
    shippingDetails = {}
  ) => {
    set({ loading: true, error: null });

    try {
      const response = await axios.post("/orders", {
        products,
        shipping_address: shippingAddress,
        total_price: totalPrice,
        reference,
        measurement,
        name,
        email,
        telephone,
        order_date: orderDate,
        ...shippingDetails,
      });

      useCartStore.getState().clearCartLocal();

      set((state) => ({
        orders: response.data.order
          ? [response.data.order, ...state.orders]
          : state.orders,
        loading: false,
      }));

      get().getOrders().catch(() => {});
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message ||
        "Unable to create order";

      set({ loading: false, error: message });
      throw error;
    }
  },
}));
